var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tile", {
    attrs: { paddingAmount: 2, showBorder: _vm.quantity > 0 },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _vm.showImage
              ? _c(
                  "div",
                  {
                    staticClass: "col xs-5 sm-5 md-3 lg-3 xl-3 vertical-center",
                    class: _vm.stack && "wide-image",
                  },
                  [
                    _c("img", {
                      staticClass: "product-image",
                      attrs: { src: _vm.imageSource },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "text-left col xs-8 sm-8 flex product-info-container",
                class:
                  _vm.stack && _vm.showImage
                    ? "md-9"
                    : !_vm.showImage
                    ? "md-8"
                    : "md-5",
              },
              [
                _c("div", [
                  _c("h5", { staticClass: "product-name text-blue-dark" }, [
                    _vm._v(_vm._s(_vm.productName)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "sku-text font-medium text-blue-dark" },
                    [_vm._v(_vm._s(_vm.activeOffer.offerType))]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "price" }, [
                    _vm._v(
                      _vm._s(_vm.currency.toUpperCase()) +
                        _vm._s(
                          (
                            _vm.calculateTotalPrice(_vm.salesPrice) *
                            _vm.quantity
                          ).toFixed(2)
                        ) +
                        " / " +
                        _vm._s(_vm.defaultTerm)
                    ),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col xs-12 sm-12 flex quantity-info-container",
                class:
                  _vm.stack && _vm.showImage
                    ? "md-9"
                    : !_vm.showImage
                    ? "md-4"
                    : "md-4",
              },
              [
                _c("QuantityToggle", {
                  ref: "selectedQuantity",
                  attrs: {
                    max: _vm.maxPurchasableQuantity,
                    min: _vm.minPurchasableQuantity,
                    default: _vm.startingNumber,
                  },
                  on: {
                    setProductQuantity: _vm.setQuantity,
                    "max-exceeded": _vm.handleMaxExceeded,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showMaxError
              ? _c("p", { staticClass: "max-error" }, [
                  _vm._v(
                    _vm._s(
                      _vm.maxError.replace(
                        "__maxQuantity__",
                        _vm.maxPurchasableQuantity
                      )
                    )
                  ),
                ])
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }